var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.62 2.99C16.5039 2.87359 16.366 2.78123 16.2141 2.71822C16.0622 2.6552 15.8994 2.62277 15.735 2.62277C15.5706 2.62277 15.4078 2.6552 15.2559 2.71822C15.1041 2.78123 14.9661 2.87359 14.85 2.99L6.54 11.3C6.4473 11.3925 6.37375 11.5024 6.32357 11.6234C6.27339 11.7443 6.24756 11.874 6.24756 12.005C6.24756 12.136 6.27339 12.2657 6.32357 12.3866C6.37375 12.5076 6.4473 12.6175 6.54 12.71L14.85 21.02C15.34 21.51 16.13 21.51 16.62 21.02C17.11 20.53 17.11 19.74 16.62 19.25L9.38 12L16.63 4.75C17.11 4.27 17.11 3.47 16.62 2.99Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.93cf6380d1432976529e87cc3f4761e8.svg";
export { ForwardRef as ReactComponent };